var map = {
	"./base": 78,
	"./base.vue": 78,
	"./birthday": 357,
	"./birthday.vue": 357,
	"./custom-uob-2025": 359,
	"./custom-uob-2025-public": 358,
	"./custom-uob-2025-public.vue": 358,
	"./custom-uob-2025.vue": 359,
	"./custom-velaa": 360,
	"./custom-velaa.vue": 360,
	"./custom2021": 361,
	"./custom2021.vue": 361,
	"./custom2023": 367,
	"./custom2023-team1": 362,
	"./custom2023-team1.vue": 362,
	"./custom2023-team2": 363,
	"./custom2023-team2.vue": 363,
	"./custom2023-team3": 364,
	"./custom2023-team3.vue": 364,
	"./custom2023-team4": 365,
	"./custom2023-team4.vue": 365,
	"./custom2023-team5": 366,
	"./custom2023-team5.vue": 366,
	"./custom2023.vue": 367,
	"./devicedonation": 368,
	"./devicedonation.vue": 368,
	"./donate": 369,
	"./donate.vue": 369,
	"./icap": 370,
	"./icap.vue": 370,
	"./limited-education": 376,
	"./limited-education-2021": 375,
	"./limited-education-2021-group1": 371,
	"./limited-education-2021-group1.vue": 371,
	"./limited-education-2021-group2": 372,
	"./limited-education-2021-group2.vue": 372,
	"./limited-education-2021-group3": 103,
	"./limited-education-2021-group3.vue": 103,
	"./limited-education-2021-group4": 373,
	"./limited-education-2021-group4.vue": 373,
	"./limited-education-2021-group5": 374,
	"./limited-education-2021-group5.vue": 374,
	"./limited-education-2021.vue": 375,
	"./limited-education.vue": 376,
	"./phapa": 377,
	"./phapa.vue": 377,
	"./special-events": 378,
	"./special-events.vue": 378,
	"./uob": 408,
	"./uob-2023-default": 379,
	"./uob-2023-default.vue": 379,
	"./uob-2023-lovestory": 380,
	"./uob-2023-lovestory.vue": 380,
	"./uob-2023-set1": 381,
	"./uob-2023-set1.vue": 381,
	"./uob-2023-set2": 382,
	"./uob-2023-set2.vue": 382,
	"./uob-2023-set3": 383,
	"./uob-2023-set3.vue": 383,
	"./uob-2023-set4": 384,
	"./uob-2023-set4.vue": 384,
	"./uob-2024-ed-sheeran": 385,
	"./uob-2024-ed-sheeran.vue": 385,
	"./uob-2024-set-a": 386,
	"./uob-2024-set-a.vue": 386,
	"./uob-2024-set-b": 387,
	"./uob-2024-set-b.vue": 387,
	"./uob-2024-set-c": 388,
	"./uob-2024-set-c.vue": 388,
	"./uob-2024-set-combo": 389,
	"./uob-2024-set-combo.vue": 389,
	"./uob-25thanniversary-foodforgood-2024": 390,
	"./uob-25thanniversary-foodforgood-2024.vue": 390,
	"./uob-default": 391,
	"./uob-default.vue": 391,
	"./uob-heartbeat-lucky-draw-2024": 392,
	"./uob-heartbeat-lucky-draw-2024.vue": 392,
	"./uob-limitededucation-2025": 394,
	"./uob-limitededucation-2025-public": 393,
	"./uob-limitededucation-2025-public.vue": 393,
	"./uob-limitededucation-2025.vue": 394,
	"./uob-lmtedu-2024-internal-canvas-bag": 395,
	"./uob-lmtedu-2024-internal-canvas-bag.vue": 395,
	"./uob-lmtedu-2024-internal-clutch-bag": 396,
	"./uob-lmtedu-2024-internal-clutch-bag.vue": 396,
	"./uob-lmtedu-2024-internal-combo": 397,
	"./uob-lmtedu-2024-internal-combo.vue": 397,
	"./uob-lmtedu-2024-internal-foldable-bag": 398,
	"./uob-lmtedu-2024-internal-foldable-bag.vue": 398,
	"./uob-lmtedu-2024-internal-t-shirt": 399,
	"./uob-lmtedu-2024-internal-t-shirt.vue": 399,
	"./uob-lmtedu-2024-public-canvas-bag": 400,
	"./uob-lmtedu-2024-public-canvas-bag.vue": 400,
	"./uob-lmtedu-2024-public-clutch-bag": 401,
	"./uob-lmtedu-2024-public-clutch-bag.vue": 401,
	"./uob-lmtedu-2024-public-combo": 402,
	"./uob-lmtedu-2024-public-combo.vue": 402,
	"./uob-lmtedu-2024-public-foldable-bag": 403,
	"./uob-lmtedu-2024-public-foldable-bag.vue": 403,
	"./uob-lmtedu-2024-public-t-shirt": 404,
	"./uob-lmtedu-2024-public-t-shirt.vue": 404,
	"./uob-lucky-draw-2025": 405,
	"./uob-lucky-draw-2025.vue": 405,
	"./uob-run-ticket-2025": 406,
	"./uob-run-ticket-2025.vue": 406,
	"./uob-songkran-fastival-2026": 407,
	"./uob-songkran-fastival-2026.vue": 407,
	"./uob.vue": 408
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 410;


//////////////////
// WEBPACK FOOTER
// ./src/components/templates/products ^\.\/.*$
// module id = 410
// module chunks = 0